/**
 * Input type keys that GenericQuery can show/hide per mode (ModeContext.inputs).
 * When inputs is undefined, all form inputs are shown (backward compatible).
 * When inputs is an object, only keys with truthy values are shown.
 * @example { [INPUT_KEYS.companiesTags]: true, [INPUT_KEYS.question]: true }
 */
export const INPUT_KEYS = {
  companiesTags: 'companiesTags',
  agent: 'agent',
  question: 'question',
  sources: 'sources',
};
